import dashboard from './dashboard'

const zhCN = { dashboard: dashboard.zhCN }
const enUS = { dashboard: dashboard.enUS }
export default { zhCN, enUS }